import base64 from "base-64";

export type uuid = string;

/**
 * UUID Utils
 */
class Uuid {
	/**
	 * Converts hex to base64
	 */
	hexToBase64 = (str: string): string => {
		return base64.encode(String.fromCharCode.apply(null,
			str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
		);
	};

	/**
	 * Returns v4 random UUID (hex)
	 */
	hex = (): string => {
		const s:any[] = [], itoh = "0123456789abcdef";

		for (let i = 0; i < 36; i++) s[i] = Math.floor(Math.random() * 0x10);

		// Conform to RFC-4122, section 4.4
		// Set 4 high bits of time_high field to version
		s[14] = 4;

		// Specify 2 high bits of clock sequence
		s[19] = (s[19] & 0x3) | 0x8;

		// Convert to hex chars
		for (let i = 0; i < 36; i++) s[i] = itoh[s[i]];

		// Insert '-'s
		s[8] = s[13] = s[18] = s[23] = "-";

		return s.join("");
	};

	/**
	 * Returns v4 random UUID (base64)
	 */
	base64 = (): string => {
		const hexUuid = this.hex().replace(/-/g, "");

		const base64Uuid = this.hexToBase64(hexUuid)
			.replace(/\//g, "_")
			.replace(/\+/g, "-")
			.replace(/=/g, "");

		return base64Uuid;
	};
};

export default new Uuid();
